import { TypeDefinition } from "../models/generic";

export class CareerCenterEducationTypes {
    public static RetinaFellowship: TypeDefinition = { id: 1, name: "Retina Fellowship", sort: 1 };
    public static Residency: TypeDefinition = { id: 2, name: "Residency", sort: 2 };
    public static Internship: TypeDefinition = { id: 3, name: "Internship", sort: 3 };
    public static MedicalSchool: TypeDefinition = { id: 4, name: "Medical School", sort: 4 };
    public static GraduateSchool: TypeDefinition = { id: 5, name: "Graduate School", sort: 5 };
    public static College: TypeDefinition = { id: 6, name: "College", sort: 6 };
    public static Other: TypeDefinition = { id: 7, name: "Other", sort: 99 };

    public static Values: TypeDefinition[] = [
        CareerCenterEducationTypes.RetinaFellowship,
        CareerCenterEducationTypes.Residency,
        CareerCenterEducationTypes.Internship,
        CareerCenterEducationTypes.MedicalSchool,
        CareerCenterEducationTypes.GraduateSchool,
        CareerCenterEducationTypes.College,
        CareerCenterEducationTypes.Other,
    ];
}



// WEBPACK FOOTER //
// ./src/domain/CareerCenterEducationTypes.ts